import ReactDOM from 'react-dom';
import { Alert, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type NotificationType = 'success' | 'error' | 'info' | 'warning';

interface NotifyProps {
  type: NotificationType;
  message: string;
}

export const showNotification = ({ type, message }: NotifyProps) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const dismiss = () => {
    if (document.body.contains(container)) {
      document.body.removeChild(container);
    }
  };

  ReactDOM.render(
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={true}
      sx={{ position: 'fixed', zIndex: 1500 }}
    >
      <Alert
        severity={type}
        variant="standard"
        elevation={6}
        action={
          <IconButton size="small" color="inherit" onClick={dismiss}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        sx={{ minWidth: 300, fontSize: '1rem', border: 1, borderColor: type + '.main' }}
      >
        {message}
      </Alert>
    </Snackbar>,
    container
  );

  setTimeout(dismiss, 5000);
};
